document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("WholesaleContactForm");

  if (!form) return;

  const emailField = form.querySelector('input[type="email"]');
  const websiteField = document.getElementById("Website");
  const submitBtn = form.querySelector('button[type="submit"]');

  /**
   * Clear validation
   */
  form.querySelectorAll("input, textarea, select").forEach((field) => {
    field.addEventListener("input", () => {
      field.setCustomValidity("");
      field.classList.remove("field-error");
    });

    field.addEventListener("change", () => {
      field.setCustomValidity("");
      field.classList.remove("field-error");
    });
  });

  /**
   * Email validation
   */
  if (emailField) {
    emailField.addEventListener("invalid", function () {
      if (this.validity.valueMissing) {
        this.setCustomValidity("Email address is required.");
      } else if (this.validity.typeMismatch) {
        this.setCustomValidity("Make sure your email is typed correctly.");
      }
    });
  }

  /**
   * Website validation
   */
  if (websiteField) {
    websiteField.addEventListener("invalid", function () {
      if (this.validity.valueMissing) {
        this.setCustomValidity("Business website is required.");
      } else if (this.validity.typeMismatch) {
        this.setCustomValidity("Please enter a valid website URL.");
      }
    });
  }

  /**
   * Highlight first invalid field
   */
  form.addEventListener(
    "invalid",
    function (e) {
      e.target.classList.add("field-error");
    },
    true
  );

  /**
   * Submit
   */
  form.addEventListener("submit", function (e) {
    if (!form.checkValidity()) {
      const firstInvalid = form.querySelector(":invalid");

      if (firstInvalid) {
        firstInvalid.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        firstInvalid.focus();
      }

      return;
    }

    submitBtn.disabled = true;
    submitBtn.classList.add("loading");
    submitBtn.dataset.originalText = submitBtn.innerHTML;
    submitBtn.innerHTML = "Submitting...";
  });
});